import React from 'react'
import './styles/index.scss'
import 'swiper/css'
import 'swiper/css/pagination'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'
import { useSelector } from 'react-redux'
import Icon from 'icons/Icon'
import { PARTNER_LOGOS_VARIANTS } from '../../constants/uiConfig'

const PartnersLogos = ({
  showTitle,
  partnerType,
  applyFilter,
  showAll,
  data,
  toggleProviders,
  showViewMore,
  isV2Variant = false,
  enableLoop = true
}) => {
  const { languageData } = useSelector(state => state.language)
  const { general } = useSelector(state => state.uiConfig)

  // Get the payment partner config from tenant config
  const paymentPartnerConfig = general?.paymentPartnerSectionVariant || {}

  // Get the footer partner swiper mode from tenant config
  const footerPartnerSwiperMode = general?.footerPartnerSwiperMode || 'fixed'

  // Check if paymentPartnerConfig is an object with images property
  const configHasImages = typeof paymentPartnerConfig === 'object' && Array.isArray(paymentPartnerConfig.images)

  // Determine variant - either from the object's variant property or from the string value (backward compatibility)
  const variantFromConfig = configHasImages
    ? paymentPartnerConfig.variant
    : PARTNER_LOGOS_VARIANTS.V1

  // Use isV2Variant prop or check if variant from config is 'v2'
  const isV2 = isV2Variant || variantFromConfig === 'v2'

  // Use images from config
  const staticPartnerLogos = configHasImages
    ? paymentPartnerConfig.images.map(img => ({
      src: `${process.env.REACT_APP_STATIC_IMAGE}/${img.name}`,
      width: img.width || '',
      height: img.height || ''
    }))
    : []

  const settings = footerPartnerSwiperMode === 'auto'
    ? {
        modules: [Autoplay],
        spaceBetween: 30,
        slidesPerView: 'auto',
        centerInsufficientSlides: true,
        loop: enableLoop,
        autoplay: {
          delay: 100,
          disableOnInteraction: false
        },
        speed: 8500
      }
    : {
        modules: [Autoplay],
        spaceBetween: 30,
        slidesPerView: 3,
        centerInsufficientSlides: true,
        loop: enableLoop,
        autoplay: {
          delay: 100,
          disableOnInteraction: false
        },
        speed: 8500,
        breakpoints: {
          480: {
            slidesPerView: 3,
            spaceBetween: 5
          },
          600: {
            slidesPerView: 4,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 5,
            spaceBetween: 20
          },
          1024: {
            slidesPerView: 6,
            spaceBetween: 20
          },
          1324: {
            slidesPerView: 6,
            spaceBetween: 30
          },
          1440: {
            slidesPerView: 8,
            spaceBetween: 30
          }
        }
      }

  return (
    <>
      {showTitle &&
        <div className='header-title d-flex justify-content-center align-items-center'>
          <h6 className='white-color payment-partner-heading'><Icon name='shield-check' width='16' height='16' />&nbsp;
            <span>{languageData?.fastAndSecurePayments}</span>
          </h6>
        </div>}
      {partnerType === 'payments'
        ? !showAll
            ? (
              <>
                <div className={`${isV2 ? 'grey-scale-img' : ''} partners-box ${applyFilter ? 'filter-applied' : ''}`}>
                  {staticPartnerLogos?.map(({ src, width, height }) => (
                    <img key={src} src={src} width={width} height={height} className='payment-logo' alt='Partner' />
                  ))}
                </div>
              </>)
            : (
              <div className={`partners-box ${applyFilter ? 'filter-applied' : ''} ${footerPartnerSwiperMode === 'fixed' ? 'partners-swiper--fixed' : 'partners-swiper--auto'}`}>
                <Swiper
                  {...settings}
                >
                  {data && data?.map(({ depositImageUrl, withdrawImageUrl, paymentProviderId, footerImageUrl }) => {
                    const isValidUrl = (url) => url && typeof url === 'string' && !url.includes('undefined')
                    const validDepositImage = isValidUrl(depositImageUrl)
                    const validWithdrawImage = isValidUrl(withdrawImageUrl)
                    const validFooterImage = isValidUrl(footerImageUrl)

                    return (
                      (validFooterImage || validDepositImage || validWithdrawImage) && (
                        <SwiperSlide key={paymentProviderId}>
                          <img
                            width='auto'
                            height='70px'
                            src={footerImageUrl || (validDepositImage ? depositImageUrl : (validWithdrawImage ? withdrawImageUrl : `${process.env.REACT_APP_STATIC_IMAGE}/defaultpayment.svg`))}
                            alt='img'
                            className='img-providers'
                          />
                        </SwiperSlide>
                      )
                    )
                  })}
                </Swiper>
              </div>
              )
        : (
          <div
            className={`partners-box partners-box--casino-providers position-relative viewmore-applied ${applyFilter && 'filter-applied'} ${(toggleProviders || !showViewMore) && 'viewmore-applied-expanded '} ${footerPartnerSwiperMode === 'fixed' ? 'partners-swiper--fixed' : 'partners-swiper--auto'}`}
          >
            <Swiper
              {...settings}
            >
              {data && data?.map((provider, index) => (
                provider?.thumbnailUrl && !provider.thumbnailUrl.includes('undefined') && (
                  <SwiperSlide key={`provider-${provider.masterCasinoProviderId}-${index}`}>
                    <span className='partners-slide__frame'>
                      <img
                        src={provider?.thumbnailUrl}
                        alt='img'
                        width={60}
                        height={22}
                        className='img-providers'
                        loading='lazy'
                        decoding='async'
                      />
                    </span>
                  </SwiperSlide>
                )
              ))}
            </Swiper>
          </div>)}
    </>
  )
}

export default PartnersLogos
